module.exports = {
  draft: 'magenta',
  published: 'blue',
  archived: 'purple',
  application: {
    draft: 'gold',
    in_progress: 'magenta',
    submitted: 'geekblue',
    approved: 'green',
    closed: 'red',
    sent: 'magenta',
    review_required: 'geekblue',
    details_required: 'magenta',
    details_added: 'geekblue',
    decision_required: 'geekblue',
    changes_required: 'geekblue',
    change_consent_required: 'magenta',
    change_consent_submitted: 'geekblue',
    unit_unavailable: 'orange',
    payment_required: 'magenta',
    lease_required: 'geekblue',
    declined: 'red',
    stale: 'red',
    cancelled: 'red',
  },
  applicant: {
    not_invited: 'geekblue',
    not_started: 'magenta',
    in_progress: 'magenta',
    submitted: 'green',
    adding_details: 'magenta',
  },
  lease: {
    in_progress: 'gold',
    draft: 'gold',
    applicant_signing_required: 'red',
    landlord_signing_required: 'geekblue',
    upcoming: 'green',
    cancelled: 'red',
    review_required: 'geekblue',
    changes_required: 'geekblue',
    unit_assignment_required: 'geekblue',
    payment_required: 'red',
  },
  leaseDocument: {
    pending_approval: 'geekblue',
  },
  incentive: {
    draft: 'gold',
    published: 'green',
    archived: 'purple',
  },
};
